import React from "react";
import { useTranslation } from "react-i18next";
import { getProductUnitDisplay } from "../../utils/mapWooProduct";
import { getDisplayCategory, getStockStatusLabel } from "../../utils/productDisplay";
import "./ProductSummary.css";

function ProductSummary({
  product,
  showTitle = true,
  titleTag: TitleTag = "h3",
  className = "",
  variant = "default",
}) {
  const { t } = useTranslation();

  if (!product) return null;

  const category = getDisplayCategory(product.categories);
  const categoryLabel = category?.name || t("Product");
  const hasPrice = Boolean(product.formattedPrice);
  const unitDisplay = getProductUnitDisplay(product);
  const hasUnitInfo = Boolean(unitDisplay);

  return (
    <div
      className={`caf-product-summary caf-product-summary--${variant}${className ? ` ${className}` : ""}`}
    >
      <div className="caf-product-summary__meta-row">
        <span className="caf-product-summary__category">{categoryLabel}</span>
        <span
          className={`caf-product-summary__stock caf-product-summary__stock--${product.stockStatus}`}
        >
          {getStockStatusLabel(product.stockStatus, t)}
        </span>
      </div>

      {showTitle ? (
        <TitleTag className="caf-product-summary__title">{product.name}</TitleTag>
      ) : null}

      {hasPrice || hasUnitInfo ? (
        <div className="caf-product-summary__price-row" dir="ltr">
          {hasPrice ? (
            <span className="caf-product-summary__price">{product.formattedPrice}</span>
          ) : (
            <span className="caf-product-summary__price caf-product-summary__price--empty" />
          )}
          {hasUnitInfo ? (
            <span className="caf-product-summary__pack">{unitDisplay}</span>
          ) : null}
        </div>
      ) : (
        <p className="caf-product-summary__quote">{t("Request a Quote")}</p>
      )}
    </div>
  );
}

export default ProductSummary;
